import { forwardRef, useEffect, useState } from 'react';
import useLocales from 'src/hooks/useLocales';
// @mui
import {
  Card,
  Divider,
  MenuItem,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Typography,
} from '@mui/material';

import './RentPaymentSearch.css';
import EmptyContent from 'src/components/EmptyContent';
import { DateConverter } from 'src/sections/common/DateConverter';
import Scrollbar from 'src/components/Scrollbar';
import A4Wrapper from 'src/sections/@dashboard/Reports/Report/A4Wrapper';
import { useStore } from 'react-redux';
import { TableHeadCustom, TableMoreMenu } from 'src/components/table';
import PermissionBasedGuard from 'src/guards/PermissionBasedGuard';
import Iconify from 'src/components/Iconify';

// ----------------------------------------------------------------------

type Props = {
  filterButtonClicked: any;
  // StatisticalReportDetails: ExpenseStatisticalReportView | undefined;
};

export const RentPaymentTableView = forwardRef(
  (
    {
      //  StatisticalReportDetails,
      filterButtonClicked,
    }: Props,
    ref: any
  ) => {
    const {} = useStore();
    const { translate } = useLocales();
    const [openMenu, setOpenMenuActions] = useState<HTMLElement | null>(null);
    // const { loadBranchDDL, loadExpenseTypeDropdown } = commonDropdown;

    // useEffect(() => {
    //   loadBranchDDL();
    //   loadExpenseTypeDropdown();

    //   // eslint-disable-next-line react-hooks/exhaustive-deps
    // }, []);
    useEffect(() => {}, [filterButtonClicked]);
    // useEffect(() => {}, [StatisticalReportDetails]);

    // Loan Report Grand Total
    const calculateTotals = (): { totalDollor: number; totalAfghani: number } => {
      let totalDollor = 0;
      let totalAfghani = 0;

      // StatisticalReportDetails?.report!.forEach((data) => {
      //   data.expenseTypes!.forEach((action) => {
      //     totalDollor += action.dollor! | 0;
      //     totalAfghani += action.afghani! | 0;
      //   });
      // });

      return { totalDollor, totalAfghani };
    };
    const handleOpenMenu = (event: React.MouseEvent<HTMLElement>) => {
      setOpenMenuActions(event.currentTarget);
    };

    const handleCloseMenu = () => {
      setOpenMenuActions(null);
    };

    const SHOP_HEAD = [
      { id: 'shopId', label: `${translate('blockDetail.No')}`, align: 'left' },
      { id: 'shopCode', label: `${translate('blockDetail.shopCode')}`, align: 'left' },
      { id: 'shopStatus', label: `${translate('blockDetail.shopStatus')}`, align: 'left' },
      { id: 'shopWidth', label: `${translate('blockDetail.shopWidth')}`, align: 'left' },
      { id: 'shopLength', label: `${translate('blockDetail.shopLength')}`, align: 'left' },
      { id: 'rentPerMonth', label: `${translate('blockDetail.rentPerMonth')}`, align: 'left' },
      { id: 'action', label: `${translate('blockDetail.action')}`, align: 'left' },
    ];

    return (
      <Card sx={{ padding: '10px', height: 'auto', marginLeft: '10px', paddingTop: '30px' }}>
        <Card sx={{ borderRadius: 2, boxShadow: 3 }}>
          <Typography variant="h6" sx={{ p: 2, fontWeight: 'bold' }}>
            {translate('blockDetail.shops')}
          </Typography>
          <Scrollbar>
            <TableContainer sx={{ minWidth: 720 }}>
              <Table>
                <TableHeadCustom headLabel={SHOP_HEAD} />
                <TableBody>
                  {/* {row.shops.length > 0 ? (
                    row.shops.map((shop, index) => ( */}
                  <TableRow>
                    <TableCell align="left">1</TableCell>
                    <TableCell align="left">test</TableCell>
                    <TableCell align="left">test</TableCell>
                    <TableCell align="left">test</TableCell>
                    <TableCell align="left">test</TableCell>
                    <TableCell align="left">test</TableCell>
                    <TableCell align="left">
                      <TableMoreMenu
                        open={openMenu}
                        onOpen={handleOpenMenu}
                        onClose={handleCloseMenu}
                        actions={
                          <>
                            <PermissionBasedGuard permissions={['Block-Delete']}>
                              <MenuItem
                                onClick={() => {
                                  // onDeleteRow();
                                  handleCloseMenu();
                                }}
                                sx={{ color: 'success.main' }}
                              >
                                <Iconify icon={'eva:trash-2-outline'} />
                                {translate('CRUD.payRent')}
                              </MenuItem>
                            </PermissionBasedGuard>
                          </>
                        }
                      />
                    </TableCell>
                  </TableRow>
                  {/* ))
                  ) : (
                    <TableRow>
                      <TableCell align="center" colSpan={SHOP_HEAD.length}>
                        {translate('blockDetail.noShops')}
                      </TableCell>
                    </TableRow>
                  )} */}
                </TableBody>
              </Table>
            </TableContainer>
          </Scrollbar>
          <Divider sx={{ borderColor: 'grey.700' }} />
        </Card>
      </Card>
    );
  }
);

// ----------------------------------------------------------------------
